module.exports = __webpack_public_path__ + "static/media/b2.cb6bab8b.jpg";